<template>
  <div @click.stop="showEmoji">
    <img src="@/static/icon/chat/smile.svg" alt="" class="action smileT mr-2">
    <div v-if="showEmojiBoard" class="emoji-board" v-click-outside="closeEvent">
      <span
        class="emoji"
        v-for="(emoji, index) in emojis"
        :key="index"
        :alt="emoji.name"
        @click="addEmojiToMessage(emoji.emoji)"
      >{{emoji.emoji}}</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: "EmojiT",
    props: {
      addEmojiToMessage: { type: Function }
    },
    data() {
      return {
        showEmojiBoard: false,
        emojis: [
          { emoji: "😁", name: "grinning face with smiling eyes" },
          { emoji: "😂", name: "face with tears of joy" },
          { emoji: "😃", name: "smiling face with open mouth" },
          { emoji: "😄", name: "smiling face with open mouth and smiling eyes" },
          { emoji: "😅", name: "smiling face with open mouth and cold sweat" },
          {
            emoji: "😆",
            name: "smiling face with open mouth and tightly-closed eyes"
          },
          { emoji: "😉", name: "winking face" },
          { emoji: "😊", name: "smiling face with smiling eyes" },
          { emoji: "😋", name: "face savouring delicious food" },
          { emoji: "😌", name: "relieved face" },
          { emoji: "😍", name: "smiling face with heart-shaped eyes" },
          { emoji: "😏", name: "smirking face" },
          { emoji: "😒", name: "unamused face" },
          { emoji: "😓", name: "face with cold sweat" },
          { emoji: "😔", name: "pensive face" },
          { emoji: "😖", name: "confounded face" },
          { emoji: "😘", name: "face throwing a kiss" },
          { emoji: "😚", name: "kissing face with closed eyes" },
          { emoji: "😜", name: "face with stuck-out tongue and winking eye" },
          {
            emoji: "😝",
            name: "face with stuck-out tongue and tightly-closed eyes"
          },
          { emoji: "😞", name: "disappointed face" },
          { emoji: "😠", name: "angry face" },
          { emoji: "😡", name: "pouting face" },
          { emoji: "😢", name: "crying face" },
          { emoji: "😣", name: "persevering face" },
          { emoji: "😤", name: "face with look of triumph" },
          { emoji: "😥", name: "disappointed but relieved face" },
          { emoji: "😨", name: "fearful face" },
          { emoji: "😩", name: "weary face" },
          { emoji: "😪", name: "sleepy face" },
          { emoji: "😫", name: "tired face" },
          { emoji: "😭", name: "loudly crying face" },
          { emoji: "😰", name: "face with open mouth and cold sweat" },
          { emoji: "😱", name: "face screaming in fear" },
          { emoji: "😲", name: "astonished face" },
          { emoji: "😳", name: "flushed face" },
          { emoji: "😵", name: "dizzy face" },
          { emoji: "😷", name: "face with medical mask" },
          { emoji: "😸", name: "grinning cat face with smiling eyes" },
          { emoji: "😹", name: "cat face with tears of joy" },
          { emoji: "😺", name: "smiling cat face with open mouth" },
          { emoji: "😻", name: "smiling cat face with heart-shaped eyes" },
          { emoji: "😼", name: "cat face with wry smile" },
          { emoji: "😽", name: "kissing cat face with closed eyes" },
          { emoji: "😾", name: "pouting cat face" },
          { emoji: "😿", name: "crying cat face" },
          { emoji: "🙀", name: "weary cat face" },
          { emoji: "🙅", name: "face with no good gesture" },
          { emoji: "🙆", name: "face with ok gesture" },
          { emoji: "🙇", name: "person bowing deeply" },
          { emoji: "🙈", name: "see-no-evil monkey" },
          { emoji: "🙉", name: "hear-no-evil monkey" },
          { emoji: "🙊", name: "speak-no-evil monkey" },
          { emoji: "🙋", name: "happy person raising one hand" },
          { emoji: "🙌", name: "person raising both hands in celebration" },
          { emoji: "🙍", name: "person frowning" },
          { emoji: "🙎", name: "person with pouting face" },
          { emoji: "🙏", name: "person with folded hands" },
          { name: "Happy", emoji: "😀" },
          { name: "Angry", emoji: "😠" },
          { name: "Really Angry", emoji: "😡" },
          { name: "Really Sad", emoji: "☹️" },
          { name: "Poop", emoji: "💩" },
          { name: "Smiling face with hearts", emoji: "🥰" }
        ]
      };
    },
    methods: {
      showEmoji() {
        this.showEmojiBoard = true;
      },

      // addEmojiToMessage(emoji) {
      //   this.$emit("add-emoji-to-message", emoji.emoji);
      // },
      closeEvent() {
        if (this.showEmojiBoard) this.showEmojiBoard = false;
        this.alertContent = null;
      }
    },
    directives: {
      "click-outside": {
        bind: function(el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== "function") {
            const compName = vNode.context.name;
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
            if (compName) {
              warn += `Found in component '${compName}'`;
            }

            console.warn(warn);
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble;
          const handler = e => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e);
            }
          };
          el.__vueClickOutside__ = handler;

          // add Event Listeners
          document.addEventListener("click", handler);
        },

        unbind: function(el) {
          // Remove Event Listeners
          document.removeEventListener("click", el.__vueClickOutside__);
          el.__vueClickOutside__ = null;
        }
      }
    }
  };
</script>
<style lang="css" scoped>
  .emoji-board {
    border-radius: 5px;
    position: absolute;
    padding: 10px;
    border: 1px solid #dfdfdf;
    bottom: 45px;
    right: 45px;
    background: #fff;
    -webkit-box-shadow: 0px 0px 10px #dfdfdf;
    box-shadow: 0px 0px 10px #dfdfdf;
    z-index: 2;
    width: 286px;
  }
  .emoji-board::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 51px;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-top-color: #fff;
    border-bottom: 0;
    margin-left: -8px;
    margin-bottom: -8px;
  }
  .emoji-board .emoji {
    cursor: pointer;
    width: 33px;
    font-size: 21px;
    display: inline-block;
    height: 30px;
  }
  .smileT {
    margin-right: 10px;
    cursor: pointer;
    width: 28px;
  }
</style>
